import { ThemeUIStyleObject } from "theme-ui"

export const textContainerStyle: ThemeUIStyleObject = {
  maxWidth: "width.2",
}

export const textContainerFaqStyle: ThemeUIStyleObject = {
  pt: ["140px", "160px", "300px"],
  pb: [15, 17, 19],
}
